module.exports = __webpack_public_path__ + "img/HBHelp-gradient.6e1f5cda.svg";